import { FC, TextareaHTMLAttributes } from 'react';
import { InputProps } from '../../utils/models';

import css from '../themed/input/input.module.scss';

type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & InputProps;

const TextArea: FC<TextAreaProps> = ({ name, label, error, ...rest }) => {
	const getValidClassName = (): string => {
		let defaultClass: string = css['form-input-group-field'];
		if (error) defaultClass += ` ${css['form-input-group-invalid']}`;

		return defaultClass;
	};

	return (
		<div className={css['form-input-group']}>
			{label && <label htmlFor={name}>{label}:</label>}

			<textarea
				className={getValidClassName()}
				name={name}
				id={name}
				{...rest}
			></textarea>

			{error && <div className="error">{error} </div>}
		</div>
	);
};

export default TextArea;
